/* =============================================================================
   Mundo TEC · medicion de storefront + "personas que vieron el producto"
   -----------------------------------------------------------------------------
   Manda eventos a VAGO Cloud (el backend propio, no un tercero) y, de paso,
   pinta cuanta gente vio la ficha. Las dos cosas viven en el mismo archivo
   porque son la misma llamada: el POST de 'view_item' DEVUELVE el conteo, asi
   que no hay una segunda peticion solo para leerlo.

   Por que el numero es honesto: el backend cuenta SESIONES DISTINTAS de las
   ultimas 24 horas, no gente conectada ahora mismo. Por eso el texto dice
   "vieron este producto", en pasado. Decir "estan viendo" seria inventar
   simultaneidad que el dato no respalda.

   Se muestra recien desde 2 personas: con 1 el mensaje no aporta y delata que
   la ficha casi no tiene visitas.

   Ventana adaptativa: primero mira las ultimas 24 h y, si no llega al minimo,
   pregunta por los ultimos 7 dias. Mundo TEC no tiene el trafico para que cada
   ficha junte 2 visitantes distintos en un dia, asi que con ventana fija de 24 h
   el modulo quedaba invisible casi siempre. El texto DICE cual ventana esta
   usando: bajar el minimo a 1 o inflar el numero seria mas facil y mentira.

   Los eventos se enganchan por atributos de Shopify, no por clases de Elixira
   ([name="add"], [name="checkout"], forms a /cart/add). Asi el modulo sobrevive
   a un cambio de tema y no depende de nombres de clase del tema de pago.

   Los comentarios van sin tildes; los textos que ve el cliente SI las llevan.

   Config: window.MT_TRACK = { store, endpoint, minimo }
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.MT_TRACK || {};
  var endpoint = cfg.endpoint || '';
  var store = cfg.store || '';
  var MINIMO = cfg.minimo || 2;

  if (!endpoint || !store) return;

  // Una sesion por pestania: es la unidad que cuenta el backend.
  var SID_KEY = 'mt_sid';
  var sid = '';
  try {
    sid = sessionStorage.getItem(SID_KEY) || '';
    if (!sid) {
      sid = 's_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem(SID_KEY, sid);
    }
  } catch (e) {
    // Navegacion privada con almacenamiento bloqueado: se sigue midiendo, pero
    // cada carga cuenta como sesion nueva. Preferible a no medir nada.
    sid = 's_' + Date.now().toString(36);
  }

  function cuerpo(nombre, datos) {
    return JSON.stringify({
      event: nombre,
      store: store,
      session_id: sid,
      path: location.pathname,
      url: location.href,
      data: datos || {}
    });
  }

  // Eventos "de paso" (clics, salida): sendBeacon sobrevive a la navegacion.
  function enviar(nombre, datos) {
    var body = cuerpo(nombre, datos);
    if (navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(endpoint, new Blob([body], { type: 'application/json' }))) return;
      } catch (e) { /* cae al fetch */ }
    }
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      keepalive: true,
      credentials: 'omit'
    }).catch(function () {});
  }

  // ── Contador de la ficha ──
  function pintar(caja, cuantos, ventana) {
    if (!cuantos || cuantos < MINIMO) return false; // sin ruido cuando no hay dato
    var texto = caja.querySelector('[data-mt-viewers-text]');
    if (!texto) return false;
    texto.innerHTML = '<strong>' + cuantos + ' personas</strong> vieron este producto ' +
      '<span class="mt-viewers__tail">' + ventana + '</span>';
    caja.hidden = false;
    return true;
  }

  // Consulta de respaldo con ventana larga. Solo se dispara si las 24 h no
  // alcanzaron: en una ficha con movimiento no se gasta una segunda peticion.
  function intentarSemana(caja, productId) {
    fetch(endpoint.replace('/events/', '/product-views/') +
          '?store=' + encodeURIComponent(store) +
          '&product_id=' + encodeURIComponent(productId) + '&hours=168',
          { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && typeof d.count === 'number') {
          pintar(caja, d.count, 'en los últimos 7 días');
        }
      })
      .catch(function () {});
  }

  // El id de producto sale de ShopifyAnalytics, que Shopify inyecta via
  // content_for_header en toda tienda. No depende de Elixira ni del tema.
  function idDeProducto() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (!meta) return '';
      if (meta.product && meta.product.id) return String(meta.product.id);
      if (meta.page && meta.page.pageType === 'product' && meta.page.resourceId) {
        return String(meta.page.resourceId);
      }
    } catch (e) { /* sin analytics no hay contador, y punto */ }
    return '';
  }

  // Se inserta solo, como mt-cards.js con las tarjetas y mt-drawer.js con el
  // cajon: asi no hay que tocar templates/product.json ni un archivo del tema.
  // Va debajo del "llega hoy" o del ahorro, que es donde se leen las senales
  // cortas de la ficha. Si ya existe el bloque puesto a mano desde el editor,
  // se respeta ese lugar y no se inyecta nada.
  function cajaDelContador() {
    var caja = document.querySelector('[data-mt-viewers]');
    if (caja) return caja;

    var productId = idDeProducto();
    if (!productId) return null;

    // En ese orden: primero las senales cortas, y si el producto no tiene ni
    // llega-hoy ni ahorro, debajo del bloque de precios. Sin ancla no se
    // inyecta: es preferible que no aparezca a que caiga en cualquier lado.
    var ancla = document.querySelector('[data-mt-today]') ||
                document.querySelector('[data-mt-save]') ||
                document.querySelector('[data-mt-pay]');
    if (!ancla) return null;

    caja = document.createElement('p');
    caja.className = 'mt-viewers';
    caja.setAttribute('data-mt-viewers', '');
    caja.setAttribute('data-product-id', productId);
    caja.hidden = true;
    caja.innerHTML = '<span class="mt-viewers__dot" aria-hidden="true"></span>' +
                     '<span data-mt-viewers-text></span>';
    ancla.insertAdjacentElement('afterend', caja);
    return caja;
  }

  function verFicha() {
    var caja = cajaDelContador();
    if (!caja) return;

    var productId = caja.getAttribute('data-product-id') || '';
    if (!productId) return;

    // fetch y no sendBeacon: aca SI interesa la respuesta.
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: cuerpo('view_item', { product_id: productId }),
      credentials: 'omit'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var n = d && typeof d.view_count === 'number' ? d.view_count : 0;
        if (!pintar(caja, n, 'en las últimas 24 h')) intentarSemana(caja, productId);
      })
      .catch(function () {});
  }

  // ── Enganches ──
  enviar('page_view', { title: document.title });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verFicha);
  } else {
    verFicha();
  }

  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[name="add"], [name="checkout"]') : null;
    if (!el) return;
    var nombre = el.getAttribute('name') === 'checkout' ? 'begin_checkout' : 'add_to_cart';
    enviar(nombre, { product_id: el.getAttribute('data-product-id') || undefined });
  }, true);

  // El carrito de Elixira agrega por fetch, no por submit; se cubren los dos.
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      enviar('add_to_cart', { form_action: form.action });
    }
  }, true);

  window.mtTrack = enviar;
})();
